/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import { middleware } from '@core/js/store/middleware';
import { staticReducers } from '@core/js/store/staticReducers';
import { ReducerService } from '@core/js/services/reducer.service';
import { createStore, applyMiddleware, compose } from 'redux';

const reducerService = new ReducerService<typeof staticReducers>(staticReducers);

// const isDev = process.env.NODE_ENV === 'development';

declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
	}
}

// const stateSanitizer = (state: any) => {
//   const validKeys = Object.keys(staticReducers);
//   return Object.keys(state)
//     .filter((key) => validKeys.includes(key))
//     .reduce((acc, key) => ({ ...acc, [key]: state[key] }), {});
// };

// TODO: fix or remove redux dev tools
// eslint-disable-next-line no-underscore-dangle
// const composeEnhancers = (isDev && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({
// 	shouldHotReload: false,
// 	stateSanitizer
// })) || compose;

const store = createStore(
	reducerService.combinedReducer,
	compose(
		applyMiddleware(
			...middleware
		)
	)
);

export {
	store,
	reducerService
};
